/* eslint-disable react/no-array-index-key */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, {useState} from 'react';

import stylesAutoLayout from '../AutoLayout.less';
import styles from './ChangeItem.less';
import ChangeItemContent from './ChangeItemContent';
import ChangeItemHeader from './ChangeItemHeader';
import AutoLayoutService from 'src/js/lib/auto_layout/auto_layout_service';
import {ContentProperty} from 'src/js/model/auto_layout_content_schema';
import {LayoutProperty} from 'src/js/model/auto_layout_layout_schema';
import {MetadataSchema} from 'src/js/model/auto_layout_metadata_schema';

const ChangeItem = ({data, idSuffix, inputName, isLast, screenId}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div
      name={inputName}
      id={AutoLayoutService.getComponentId(screenId, inputName, idSuffix)}
      className={classNames(
        styles.dlChangeItem,
        stylesAutoLayout.dlScreenComponentInput,
        {[styles.dlChangeItemBorder]: !isLast}
      )}
    >
      <ChangeItemHeader
        data={data}
        isLast={isLast}
        isExpanded={isExpanded}
        handleExpand={handleExpand}
      />
      {isExpanded && <ChangeItemContent data={data} />}
    </div>
  );
};

ChangeItem.displayName = 'ChangeItem';

/* eslint-disable react/no-unused-prop-types */
ChangeItem.propTypes = {
  content: PropTypes.instanceOf(ContentProperty).isRequired,
  layout: PropTypes.instanceOf(LayoutProperty).isRequired,
  metadata: PropTypes.instanceOf(MetadataSchema).isRequired,
  screenId: PropTypes.string.isRequired,
  idSuffix: PropTypes.string,
  isLast: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
  pathToData: PropTypes.string,
  isReadOnly: PropTypes.bool,
  isTextOnly: PropTypes.bool,
  inputName: PropTypes.string,
  label: PropTypes.string,
  expanded: PropTypes.bool,
  onDataChange: PropTypes.func.isRequired,
};

ChangeItem.defaultProps = {
  data: {},
  idSuffix: '',
  pathToData: '',
  isReadOnly: false,
  isTextOnly: false,
  inputName: '',
  label: '',
  expanded: false,
};

export default ChangeItem;
